/* eslint-disable react/no-array-index-key */
import React, { useState, useMemo, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Grid, Heading, Text, Box, Anchor, Image } from 'wt-ui';
import AudioPlayer from '../AudioPlayer/AudioPlayer';
import Pagination from '../Pagination';
import useResponsive from '../../hooks/useResponsive';
import Header from '../Header';
import Config from '../../services/Config';
import Utils from '../../services/Utils';
import CircleIcon from '../../assets/icons/CircleIcon';

import './index.css';

const PAGE_SIZE = Number(Config.podcastsNumToShow);

const RSSFeedView = ({ podcastList }) => {
  const defaultFilter = Config.defaultFilterName;
  const showFilter = Config.enableFilter === 'true'; // && !defaultFilter;

  const { isMobile, isTablet, isDesktopOrLaptop } = useResponsive();
  const elementsSize = isTablet ? '98px' : '161px';
  const [currentPage, setCurrentPage] = useState(1);
  const [filterTypes, setFilterType] = useState([defaultFilter || '']);
  const toLowerCase = (val) => (val ? val.toLowerCase() : '');

  const filteredItems = filterTypes.length <= 0
    ? podcastList
    : podcastList.filter((podcast) => filterTypes.some((filter) => toLowerCase(podcast.podcastTitle).includes(toLowerCase(filter))));

  const currentTableData = useMemo(() => {
    const firstPageIndex = (currentPage - 1) * PAGE_SIZE;
    const lastPageIndex = firstPageIndex + PAGE_SIZE;
    return filteredItems.slice(firstPageIndex, lastPageIndex);
  }, [filteredItems, currentPage]);

  const setSelectedFilter = (filterList) => {
    setCurrentPage(1);
    setFilterType(filterList);
  };

  useEffect(() => {}, [podcastList, filteredItems, currentTableData]);

  return (
    <>
      {showFilter && <Header setSelectedFilter={setSelectedFilter} podcastList={podcastList} /> }

      {currentTableData
        && currentTableData.length > 0
        && currentTableData.map((item, idx) => {
          const {
            wtLink,
            podcastSeries,
            podcastTitle,
            published,
            image,
            audioLink,
            guid,
            author,
          } = item;

          return (
            <React.Fragment key={`${guid}-${idx}`}>
              <Box
                background="transparent"
                direction="row-responsive"
                pad="medium"
                className="rss"
              >
                <Grid
                  responsive={false}
                  rows={['flex']}
                  columns={[[elementsSize, elementsSize], 'auto']}
                  style={{ width: '100%' }}
                  areas={[
                    { name: 'img', start: [0, 0], end: [0, 0] },
                    { name: 'main', start: [1, 0], end: [1, 0] },
                  ]}
                >
                  <Box
                    gridArea="img"
                    height={{ max: elementsSize }}
                    width={{ max: elementsSize }}
                    elevation="large"
                    background="transparent"
                    direction="row-responsive"
                    style={{ display: 'block' }}
                  >
                    <Image
                      src={image}
                      width={elementsSize}
                      height={elementsSize}
                      alt="Wisdom tree podcast image"
                      className="image-container"
                      style={{ borderTopLeftRadius: '5px' }}
                    />
                  </Box>
                  <Box
                    gridArea="main"
                    elevation="large"
                    background="transparent"
                    direction="row-responsive"
                    pad="none"
                    className={classNames('text_container ')}
                    flex
                  >
                    <Heading
                      a11yTitle={podcastTitle}
                      pad="none"
                      className={classNames('podcast_title--heading', {
                        m_heading: isTablet,
                        lg_heading: isDesktopOrLaptop,
                      })}
                    >
                      {podcastTitle}
                    </Heading>
                    <Box
                      background="transparent"
                      direction="row-responsive"
                      pad={{ vertical: '5px', left: '10px' }}
                      a11yTitle={podcastSeries}
                      style={{ alignItems: 'center', gap: '5px' }}
                    >
                      {!isMobile && (
                        <Text as="div" className="text_format">{podcastSeries}</Text>
                      )}
                      {!isTablet && (
                        <>
                          <CircleIcon />
                          <Anchor href={wtLink} target="_blank" primary>
                            By {author}
                          </Anchor>
                          <CircleIcon />
                          <Text as="div" className="text_format">{Utils.formatDate(published)}</Text>
                        </>
                      )}
                    </Box>
                    <AudioPlayer
                      audioLink={audioLink}
                      itemTitle={podcastTitle}
                    />
                  </Box>
                </Grid>
              </Box>
            </React.Fragment>
          );
        })}

      {currentTableData && currentTableData.length === 0 && (
      <Box
        background="transparent"
        direction="row-responsive"
        pad="medium"
        a11yTitle="Pagination"
        justify="center"
        elevation="medium"
        margin="medium"
        style={{ border: '1px solid #ddd' }}
      >
        No podcast found.
      </Box>
      )}
      {currentTableData && currentTableData.length > 0 && (
        <Box
          background="transparent"
          direction="row-responsive"
          pad="medium"
          a11yTitle="Pagination"
          justify="center"
        >
          <Pagination
            className="pagination-bar"
            currentPage={currentPage}
            totalCount={filteredItems.length}
            pageSize={PAGE_SIZE}
            onPageChange={(page) => setCurrentPage(page)}
            siblingCount={1}
          />
        </Box>
      )}
    </>
  );
};

RSSFeedView.defaultProps = {
  podcastList: [],
};

RSSFeedView.propTypes = {
  podcastList: PropTypes.arrayOf(PropTypes.shape({})),
};

export default RSSFeedView;
